// Stable identifiers shared by the CMS, the app and the database catalogue.
export const CATEGORY_CATALOG_VERSION = 2;
export const CATEGORY_ICON_LABELS = {
  Music: 'Música', Drum: 'Tambor', Disc3: 'Disco', Star: 'Estrela',
  Palette: 'Paleta', Drama: 'Teatro', MicVocal: 'Microfone', Clapperboard: 'Cinema',
  Utensils: 'Talheres', SportShoe: 'Tênis', Leaf: 'Folha', Brush: 'Pincel',
  ShoppingBasket: 'Cesta', BookOpenText: 'Livro', Gamepad2: 'Controle de jogo',
  Dumbbell: 'Halter', Presentation: 'Apresentação', PawPrint: 'Pata',
  HandHelping: 'Solidariedade', Trophy: 'Troféu', PartyPopper: 'Confete',
  Sparkles: 'Brilhos', Tent: 'Tenda', Flame: 'Chama', Ghost: 'Fantasma',
  Gift: 'Presente', Heart: 'Coração', Camera: 'Câmera', Mountain: 'Montanha',
  Bike: 'Bicicleta', Landmark: 'Patrimônio', Sun: 'Sol', Moon: 'Lua',
  Flag: 'Bandeira', LayoutGrid: 'Grade',
} as const;
export type CategoryIconKey = keyof typeof CATEGORY_ICON_LABELS;
export const CATEGORY_COLOR_LABELS = {
  '#C8458D': 'Música e celebrações', '#CD4A46': 'Espetáculos',
  '#967200': 'Arte e cultura', '#8664CA': 'Cinema e jogos',
  '#BA5E1F': 'Gastronomia e feiras', '#0C8A38': 'Natureza e movimento',
  '#0278D7': 'Aprendizado', '#0B838F': 'Comunidade',
} as const;
